import { Inject, Injectable } from '@angular/core'
import { EventHubGetProvider, HasEventHubIDs } from './signup.interface'
import { Observable, of, ReplaySubject } from 'rxjs'
import { filter, flatMap, map } from 'rxjs/operators'
import { EVENT_HUB_GET_PROVIDER } from './signup.token'

@Injectable({
  providedIn: 'root'
})
export class SignupLiveEventService {
  private readonly liveEventSubject = new ReplaySubject<HasEventHubIDs | undefined>(1)

  /** Returns the asset url for the first event hub for a live event. */
  public readonly eventHubAsset$: Observable<string> = this.liveEventSubject.pipe(
    flatMap(liveEvent => {
      if (liveEvent === undefined || liveEvent.event_ids.length < 1) return of(null)
      return this.eventsService.getEvent(liveEvent.event_ids[0])
    }),
    map(eventResponse => {
      return eventResponse === null ? null : eventResponse.data.asset_url
    }),
    filter<string>(Boolean)
  )

  public constructor(@Inject(EVENT_HUB_GET_PROVIDER) private readonly eventsService: EventHubGetProvider) {}

  /** Update the live event for providing data via public observables. */
  public updateLiveEvent(liveEvent: HasEventHubIDs | undefined): void {
    this.liveEventSubject.next(liveEvent)
  }
}
